import { Prefecture } from "@/types/prefecture";

export const PREFECTURE_LABELS = [
  { label: "北海道", value: Prefecture.HOKKAIDO },
  { label: "青森県", value: Prefecture.AOMORI },
  { label: "岩手県", value: Prefecture.IWATE },
  { label: "宮城県", value: Prefecture.MIYAGI },
  { label: "秋田県", value: Prefecture.AKITA },
  { label: "山形県", value: Prefecture.YAMAGATA },
  { label: "福島県", value: Prefecture.FUKUSHIMA },
  { label: "茨城県", value: Prefecture.IBARAKI },
  { label: "栃木県", value: Prefecture.TOCHIGI },
  { label: "群馬県", value: Prefecture.GUNMA },
  { label: "埼玉県", value: Prefecture.SAITAMA },
  { label: "千葉県", value: Prefecture.CHIBA },
  { label: "東京都", value: Prefecture.TOKYO },
  { label: "神奈川県", value: Prefecture.KANAGAWA },
  { label: "新潟県", value: Prefecture.NIIGATA },
  { label: "富山県", value: Prefecture.TOYAMA },
  { label: "石川県", value: Prefecture.ISHIKAWA },
  { label: "福井県", value: Prefecture.FUKUI },
  { label: "山梨県", value: Prefecture.YAMANASHI },
  { label: "長野県", value: Prefecture.NAGANO },
  { label: "岐阜県", value: Prefecture.GIFU },
  { label: "静岡県", value: Prefecture.SHIZUOKA },
  { label: "愛知県", value: Prefecture.AICHI },
  { label: "三重県", value: Prefecture.MIE },
  { label: "滋賀県", value: Prefecture.SHIGA },
  { label: "京都府", value: Prefecture.KYOTO },
  { label: "大阪府", value: Prefecture.OSAKA },
  { label: "兵庫県", value: Prefecture.HYOGO },
  { label: "奈良県", value: Prefecture.NARA },
  { label: "和歌山県", value: Prefecture.WAKAYAMA },
  { label: "鳥取県", value: Prefecture.TOTTORI },
  { label: "島根県", value: Prefecture.SHIMANE },
  { label: "岡山県", value: Prefecture.OKAYAMA },
  { label: "広島県", value: Prefecture.HIROSHIMA },
  { label: "山口県", value: Prefecture.YAMAGUCHI },
  { label: "徳島県", value: Prefecture.TOKUSHIMA },
  { label: "香川県", value: Prefecture.KAGAWA },
  { label: "愛媛県", value: Prefecture.EHIME },
  { label: "高知県", value: Prefecture.KOCHI },
  { label: "福岡県", value: Prefecture.FUKUOKA },
  { label: "佐賀県", value: Prefecture.SAGA },
  { label: "長崎県", value: Prefecture.NAGASAKI },
  { label: "熊本県", value: Prefecture.KUMAMOTO },
  { label: "大分県", value: Prefecture.OITA },
  { label: "宮崎県", value: Prefecture.MIYAZAKI },
  { label: "鹿児島県", value: Prefecture.KAGOSHIMA },
  { label: "沖縄県", value: Prefecture.OKINAWA },
];

export const PREFECTURE_STRING_VALUE_LABELS = [
  ...PREFECTURE_LABELS.map((prefecture) => ({
    label: prefecture.label,
    value: prefecture.value.toString(),
  })),
];
